<script setup>
import { computed, getCurrentInstance } from 'vue';

const props = defineProps({
    defaultClass: String,
    activeClass: String,
    activeValue: Boolean
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Computed ---

const darkModeBtnClass = computed(() => {
    // 1. Determine the base theme class from store preference
    const isDarkMode = store.getters['user/pref']('darkMode');
    const themeBaseClass = isDarkMode ? 'btn-dark' : 'btn-light btn-white';

    // 2. If the button is "active", determine the highlight class
    if (props.activeValue) {
        return props.activeClass === undefined
            ? 'btn-warning'
            : props.activeClass;
    }

    // 3. Otherwise, return the default class or the theme base
    return props.defaultClass || themeBaseClass;
});
</script>

<template>
    <button type="button" class="btn" :class="darkModeBtnClass">
        <slot/>
    </button>
</template>

<style scoped>
.btn-white:not(:hover) {
    background-color: #fff;
    border-color: #fff;
}

/*
    In light mode, buttons have a light grey background.
    The following removes it, but :not is required to allow light text colours
    for background colours.
*/
[data-bs-theme="light"] button:not(:hover):not(.btn-primary, .btn-secondary, .btn-warning, .btn-light, .btn-dark, .btn-danger, .btn-success) {
    background-color: transparent;
    border-color: transparent;
}

/* When a light button is inside a light button apply a lighter bg color
   when hovering on the inner button to add contrast between them.
 */
[data-bs-theme="light"] .btn .btn:hover {
    background-color: #fff !important;
}
[data-bs-theme="dark"] .btn .btn:hover {
    background-color: #333 !important;
}
</style>